<template>
  <div class="layout">
    <aside class="layout-aside">
      <div class="brand">
        <div class="brand-logo">
          <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="24" cy="24" r="24" fill="#FFB020" />
            <path d="M16 18h16a3 3 0 013 3v12a3 3 0 01-3 3H16a3 3 0 01-3-3V21a3 3 0 013-3z" fill="#fff" />
            <path d="M18 18v-2a6 6 0 0112 0v2" stroke="#fff" stroke-width="2.5" fill="none" />
            <circle cx="24" cy="27" r="2.5" fill="#FFB020" />
          </svg>
        </div>
        <div class="brand-text">
          <div class="brand-name">外勤蜂</div>
          <div class="brand-desc">专业的企业服务交易平台</div>
        </div>
      </div>

      <nav class="menu-list">
        <router-link v-for="item in menus" :key="item.path" :to="item.path" class="menu-item"
          :class="{ active: activeMenu === item.path }">
          <i :class="item.icon" />
          <span class="menu-title">{{ item.title }}</span>
          <span v-if="item.badge > 0" class="menu-badge" :class="item.badgeType">
            {{ item.badge }}
          </span>
        </router-link>
      </nav>

      <div class="aside-footer">
        <div class="company-name">{{ companyName }}</div>
        <div class="company-meta">企业客户，当前员工：{{ userName }}</div>
      </div>
    </aside>

    <section class="layout-main">
      <header class="layout-header">
        <div class="header-left">
          <el-dropdown trigger="click" @command="handleCityChange">
            <span class="city-selector">
              办理城市：{{ currentCity }}
              <i class="el-icon-arrow-down" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="city in cities" :key="city" :command="city">
                {{ city }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="header-right">
          <span class="notify-btn" @click="handleNotify">
            <i class="el-icon-bell" />
            <i class="notify-dot" />
          </span>

          <el-dropdown trigger="click" @command="handleUserCommand">
            <div class="user-block">
              <div class="avatar">{{ avatarText }}</div>
              <div class="user-meta">
                <div class="user-company">{{ companyName }}</div>
                <div class="user-staff">当前员工：{{ userName }}</div>
              </div>
              <i class="el-icon-arrow-down user-arrow" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>

      <main class="layout-content" :class="{ 'is-chat': isChatPage }">
        <router-view />
      </main>
    </section>

    <!-- <button class="cs-float" type="button" @click="goChat">
      <i class="el-icon-service" />
      <span>在线客服</span>
    </button> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  data() {
    return {
      currentCity: '成都市',
      cities: ['成都市', '重庆市', '西安市', '北京市', '上海市'],
      companyName: '成都云启财税服务有限公司',
      menus: [
        { path: '/home', title: '首页', icon: 'el-icon-s-home' },
        { path: '/chat', title: '我的会话', icon: 'el-icon-chat-dot-round', badge: 2, badgeType: 'danger' },
        { path: '/services', title: '我的订单', icon: 'el-icon-document', badge: 1, badgeType: 'warning' },
        { path: '/coupons', title: '我的优惠券', icon: 'el-icon-ticket' }
      ]
    }
  },
  computed: {
    ...mapGetters(['userName', 'totalUnread', 'userInfo']),
    activeMenu() {
      return (this.$route.meta && this.$route.meta.activeMenu) || this.$route.path
    },
    isChatPage() {
      return this.$route.path === '/chat' || this.$route.path.startsWith('/chat/')
    },
    avatarText() {
      const name = this.userName || '客'
      return name.slice(0, 1)
    }
  },
  watch: {
    totalUnread: {
      immediate: true,
      handler(val) {
        const chatMenu = this.menus.find(item => item.path === '/chat')
        if (chatMenu) {
          chatMenu.badge = val || 0
        }
      }
    }
  },
  methods: {
    handleCityChange(city) {
      this.currentCity = city
      this.$message.success(`已切换办理城市为 ${city}`)
    },
    handleNotify() {
      this.$message.info('暂无新的系统通知')
    },
    handleUserCommand(command) {
      if (command === 'logout') {
        this.$confirm('确认退出登录吗？', '提示', { type: 'warning' })
          .then(() => {
            this.$store.dispatch('user/logout')
            this.$router.replace('/login')
          })
          .catch(() => { })
      }
    },
    goChat() {
      this.$router.push('/chat')
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #2f80ed;
$accent: #ff6a3d;
$bg: #f5f7fb;

.layout {
  display: flex;
  height: 100%;
  background: $bg;
  position: relative;
}

.layout-aside {
  width: 248px;
  background: #fff;
  border-right: 1px solid #eef1f6;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 20px 18px;
}

.brand-logo {
  width: 42px;
  height: 42px;
  flex-shrink: 0;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.brand-name {
  font-size: 22px;
  font-weight: 700;
  color: #1f2a37;
  line-height: 1.2;
}

.brand-desc {
  margin-top: 2px;
  font-size: 12px;
  color: #98a2b3;
}

.menu-list {
  flex: 1;
  padding: 8px 14px;
  overflow: auto;
}

.menu-item {
  display: flex;
  align-items: center;
  height: 46px;
  padding: 0 14px;
  margin-bottom: 6px;
  border-radius: 10px;
  color: #667085;
  font-size: 15px;
  transition: all 0.2s ease;

  i {
    margin-right: 10px;
    font-size: 18px;
  }

  &:hover {
    background: #f5f8ff;
    color: $primary;
  }

  &.active {
    background: #eaf2ff;
    color: $primary;
    font-weight: 600;
  }
}

.menu-title {
  flex: 1;
}

.menu-badge {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  text-align: center;

  &.danger {
    background: #f04438;
  }

  &.warning {
    background: #ff6a3d;
  }

  &:empty,
  &[data-zero='true'] {
    display: none;
  }
}

.menu-badge:not(.danger):not(.warning) {
  display: none;
}

.aside-footer {
  margin: 12px 14px 18px;
  padding: 14px;
  border-radius: 12px;
  background: #f8fafc;
}

.company-name {
  font-size: 13px;
  font-weight: 600;
  color: #344054;
  line-height: 1.4;
}

.company-meta {
  margin-top: 6px;
  font-size: 12px;
  color: #98a2b3;
  line-height: 1.4;
}

.layout-main {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.layout-header {
  height: 64px;
  padding: 0 24px;
  background: #fff;
  border-bottom: 1px solid #eef1f6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.city-selector {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #344054;
  font-size: 14px;
  cursor: pointer;

  i {
    font-size: 12px;
    color: #98a2b3;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 18px;
}

.notify-btn {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #667085;
  cursor: pointer;

  &:hover {
    background: #f5f8ff;
    color: $primary;
  }

  i.el-icon-bell {
    font-size: 18px;
  }
}

.notify-dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f04438;
}

.user-block {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #dbeafe;
  color: $primary;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.user-company {
  font-size: 13px;
  color: #344054;
  font-weight: 600;
  line-height: 1.3;
}

.user-staff {
  margin-top: 2px;
  font-size: 12px;
  color: #98a2b3;
}

.user-arrow {
  color: #98a2b3;
  font-size: 12px;
}

.layout-content {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 20px 24px 32px;

  &.is-chat {
    overflow: hidden;
    padding: 0;
    display: flex;
    flex-direction: column;
  }
}

.cs-float {
  position: fixed;
  right: 28px;
  bottom: 36px;
  z-index: 20;
  width: 64px;
  height: 64px;
  border: none;
  border-radius: 50%;
  background: linear-gradient(180deg, #3aa0ff 0%, #2f80ed 100%);
  color: #fff;
  box-shadow: 0 10px 24px rgba(47, 128, 237, 0.35);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;

  i {
    font-size: 20px;
  }

  span {
    font-size: 11px;
    transform: scale(0.92);
  }

  &:hover {
    filter: brightness(1.05);
  }
}
</style>
